/**
 * Created by Gaplo917 on 6/9/2017.
 */
import * as PIXI from 'pixi.js'
import * as Rx from 'rxjs'
import TWEEN from "@tweenjs/tween.js"
import Image from "../../objects/Image";
import R from "../../config/R";
import * as Events from "../../Events";
import {AnimationUtils} from "../../AnimationUtils";
import * as _ from "lodash";
import CustomAnimatedSprite from "../../objects/CustomAnimatedSprite";
import SoundManager from "../../SoundManager";

export class Pecker extends PIXI.Container {
  constructor(x, y, resources){
    super()
    this.x = x
    this.y = y

    const pecker = new CustomAnimatedSprite(0,0, resources, R.spines.pecker)
    this.pecker = pecker

    this.addChild(pecker)

    this.normal()
  }

  removeAllChild(){
    this.removeChildren()
  }

  normal(){
    this.pecker.playAnimation(R.spines.pecker.animations.idle, true)
  }

  pecking(){
    return Rx.Observable.create((observer) => {
      SoundManager.instance.playEffect(R.sounds.level2_woodpecker)

      this.pecker.playAnimation(R.spines.pecker.animations.peck, true)
      observer.next()
      observer.complete()
    })
    .delay(2000)
    .do(() => {
      SoundManager.instance.stopEffect(R.sounds.level2_woodpecker)
      this.normal()
    })
  }

  addOnClickListener(fn) {
    this.interactive = true
    this.buttonMode = true

    this
      .on('mousedown', () => {
      })
      .on('touchstart', () => {
      })
      .on('mouseout', () => {
      })
      .on('mouseover', () => {
      })
      .on('mouseup', (e) => {
        fn(e)
        this.removeOnClickListener()
      })
      .on('touchend', (e) => {
        fn(e)
        this.removeOnClickListener()
      })
  }

  removeOnClickListener(){
    this.interactive = false
    this.buttonMode = false

    this
      .removeListener('mousedown')
      .removeListener('touchstart')
      .removeListener('mouseup')
      .removeListener('touchend')
  }
}



// WEBPACK FOOTER //
// ./src/game/characters/level2/Pecker.js